import { render, staticRenderFns } from "./IconArrowDownSolid.vue?vue&type=template&id=3e63050d"
import script from "./IconArrowDownSolid.vue?vue&type=script&lang=js"
export * from "./IconArrowDownSolid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports